import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from '../../layout/container/container.component';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-attention-channels',
  standalone: true,
  imports: [CommonModule, ContainerComponent],
  templateUrl: './attention-channels.component.html',
  styleUrl: './attention-channels.component.scss'
})
export class AttentionChannelsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('attentionChannels', { static: false }) attentionChannels?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.attentionChannels?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.attentionChannels.nativeElement,
        'Attention Channels',
        'attention-channels-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }

  // Método para trackear click en WhatsApp
  onWhatsAppClick(): void {
    this.analyticsService.trackCTAClick(
      'Ir a Whatsapp',
      'Attention Channels',
      'button',
      { url: 'https://wa.me/56958123297', platform: 'whatsapp' }
    );
  }
}
